import {ExternalHosting, ToEmbedUrl} from './@types';

// /video/<id>, /video/private/<id>, /shorts/<id>, /play/embed/<id>
const VIDEO_PATH = /^\/(?:video\/private|video|shorts|play\/embed)\/([a-f0-9]{32})\/?$/i;

const buildEmbedUrl = (id: string, privateKey: string | null): string =>
    `https://rutube.ru/play/embed/${id}${privateKey ? `/?p=${encodeURIComponent(privateKey)}` : ''}`
;

const toRutubeEmbed: ToEmbedUrl = ({pathname, searchParams}) => {
    const [videoPath, id] = pathname.match(VIDEO_PATH) ?? [];
    const privateKey      = searchParams.get('p');

    return id
        ? buildEmbedUrl(id, privateKey)
        : null;
};

export const rutubeHosting: ExternalHosting = {
    hosts:   ['rutube.ru'],
    toEmbed: toRutubeEmbed,
};
